module.exports = __webpack_public_path__ + "img/compare.de0f1d6b.svg";